export const RESET_REPORT_EDITOR = "[TYPIST] RESET_REPORT_EDITOR";
export const SET_REPORT_EDITOR_UNSAVED_CHANGES = "[TYPIST] SET_REPORT_EDITOR_UNSAVED_CHANGES";

export const UPDATE_DICTATION_REPORT = "[TYPIST] UPDATE_DICTATION_REPORT";
export const UPDATE_DICTATION_REPORT_START = "[TYPIST] UPDATE_DICTATION_REPORT_START";
export const UPDATE_DICTATION_REPORT_SUCCESS = "[TYPIST] UPDATE_DICTATION_REPORT_SUCCESS";
export const UPDATE_DICTATION_REPORT_ERROR = "[TYPIST] UPDATE_DICTATION_REPORT_ERROR";

export const UNLOCK_REPORT_EDITOR_VISIT = "[TYPIST] UNLOCK_REPORT_EDITOR_VISIT";
export const UNLOCK_REPORT_EDITOR_VISIT_START = "[TYPIST] UNLOCK_REPORT_EDITOR_VISIT_START";
export const UNLOCK_REPORT_EDITOR_VISIT_SUCCESS = "[TYPIST] UNLOCK_REPORT_EDITOR_VISIT_SUCCESS";
export const UNLOCK_REPORT_EDITOR_VISIT_ERROR = "[TYPIST] UNLOCK_REPORT_EDITOR_VISIT_ERROR";

export const SKIP_CURRENT_AND_VIEW_NEXT_VISIT = "[TYPIST] SKIP_CURRENT_AND_VIEW_NEXT_VISIT";

export const FETCH_PATIENT_HISTORY_REPORTS = "[TYPIST] FETCH_PATIENT_HISTORY_REPORTS";
export const FETCH_PATIENT_HISTORY_REPORTS_START = "[TYPIST] FETCH_PATIENT_HISTORY_REPORTS_START";
export const FETCH_PATIENT_HISTORY_REPORTS_SUCCESS = "[TYPIST] FETCH_PATIENT_HISTORY_REPORTS_SUCCESS";
export const FETCH_PATIENT_HISTORY_REPORTS_ERROR = "[TYPIST] FETCH_PATIENT_HISTORY_REPORTS_ERROR";

export const resetReportEditor = () => {
    return {
        type: RESET_REPORT_EDITOR
    };
};

export const setReportEditorUnsavedChanges = (unsavedChanges) => {
    return {
        type: SET_REPORT_EDITOR_UNSAVED_CHANGES,
        unsavedChanges
    };
};

export const unlockReportEditorVisit = (visit, onConfirm, from) => {
    return {
        type: UNLOCK_REPORT_EDITOR_VISIT,
        payload: {
            visit,
            onConfirm,
            from
        }
    };
}

export const updateDictationReport = (dictationReport, autoNextConfig) => {
    return {
        type: UPDATE_DICTATION_REPORT,
        payload: {
            dictationReport,
            autoNextConfig
        }
    };
}

export const skipCurrentAndLoadNextVisit = (visit, autoNextConfig) => {
    return {
        type: SKIP_CURRENT_AND_VIEW_NEXT_VISIT,
        payload: {
            visit,
            autoNextConfig
        }
    };
}

export const fetchPatientHistoryReports = (visit) => {
    return {
        type: FETCH_PATIENT_HISTORY_REPORTS,
        visit,
    };
}
